import React from 'react';
import { MomentsSlider } from './MomentsSlider';
import { MomentsBanner } from './MomentsBanner';
import { MomentsContextProvider } from './MomentsContext';
import { MomentsStubContextProvider } from './MomentsStubContext';
import { ProductListModal } from './ProductListModal';

type MomentsProps = {
  subscriptionId: string;
  refetchSubscription: ({
    compareOnlyLines,
  }: {
    compareOnlyLines?: boolean;
  }) => void;
  showErrorToast: (message: string) => void;
  isStub?: boolean;
};

const Moments = ({
  subscriptionId,
  refetchSubscription,
  showErrorToast,
  isStub = false,
}: MomentsProps): JSX.Element => {
  const ContextProvider = isStub
    ? MomentsStubContextProvider
    : MomentsContextProvider;

  return (
    <section className="awt-moments">
      <ContextProvider
        value={{
          subscriptionId,
          showErrorToast,
          refetchSubscription,
        }}
      >
        <MomentsSlider />
        <MomentsBanner />
        <ProductListModal />
      </ContextProvider>
    </section>
  );
};

export default Moments;
